import { submitForm } from "./cart";
import { btnShowVariantsAjaxinate } from "./product.modal";

const cardsContainer = document.querySelector('#AjaxinateContainer');
/**
 * Function created to add events to new products loaded in collections page
 * Team: Support
 * @author Liska Loaiza <liska.loaiza@gradiweb.com>
 */
document.addEventListener('DOMContentLoaded', () => {

  const observer = new MutationObserver((mutationList) => {
    mutationList.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        const container =  mutation.addedNodes[1];
        const nodes = container.querySelectorAll('.grid .product-card');

        nodes.forEach(node => {
          const nodeVariants = node.querySelector('.btn-show-variants-js')
          // function add to cart
          submitForm(node)
          // function open modal back in stock
          window.backInStockRegisterEvents()

          if (nodeVariants != null) {
            //function open modal for variants
            btnShowVariantsAjaxinate(nodeVariants)
          }
        })
      }
    })
  })

  const observerOptions = {
    attributes: true,
    childList: true,
    subtree: false
  }

  observer.observe(cardsContainer, observerOptions);

})


